module.exports = __webpack_public_path__ + "img/350.caaedfad.jpg";